























import { createComponent } from "@vue/composition-api";
import { formValidator } from "@/shared/formValidator";
import {
  ZastosowanieCategoryAttribute,
  ZastosowanieCategoryAttributeType,
} from "@megarax/client/src/resources/plm";

const validationRules = {};

interface Props {
  value: ZastosowanieCategoryAttribute;
}

export default createComponent<Props>({
  components: {},
  props: {
    value: { required: true, type: ZastosowanieCategoryAttribute },
  },
  setup(props, ctx) {
    return {
      ...formValidator(),
      validationRules,
      zastosowanieCategoryAttributeTypeOptions: Object.keys(
        ZastosowanieCategoryAttributeType,
      ),
    };
  },
});
